import { render, staticRenderFns } from "./TrialSuggestions.vue?vue&type=template&id=04f8df8b&scoped=true&"
import script from "./TrialSuggestions.vue?vue&type=script&lang=js&"
export * from "./TrialSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8df8b",
  null
  
)

export default component.exports